<template>
  <div
    style="
      --banner-color-from: #403731;
      --banner-color-to: #005922;
    "
  >
    <router-view />
  </div>
</template>

<script setup lang="ts">
import "@as/style/app.scss";
</script>
